<template>
    <div id="checkout-content" ref="topAnchor">
        <header id="checkout-header" class="py-3" :class="{ busy: showReview }">
            <div class="content" v-if="$scope.STORE && $scope.STORE.logo_url">
                <a
                    :href="`/${$scope.STORE.url}/sacola`"
                    :title="$scope.STORE.name"
                    id="checkout-logo"
                >
                    <img
                        :src="`${$scope.CDN_IMAGES}/${$scope.STORE.logo_url}?auto=compress,format&q=65&w=320&h=38`"
                        :alt="$scope.STORE.name"
                    />
                </a>
            </div>
            <div class="content d-flex" v-else>
                <i
                    class="confirmation-logo mr-2"
                    :class="
                        $scope.TENANT_IDENTIFIER === 'chicorei'
                            ? 'logo-cr-circle'
                            : 'logo-up-circle'
                    "
                ></i>
                <a
                    id="checkout-logo"
                    :class="
                        $scope.TENANT_IDENTIFIER === 'chicorei'
                            ? 'logo-cr-text'
                            : $scope.TENANT_IDENTIFIER === 'umapenca'
                            ? 'logo-up-text bg-white'
                            : 'logo-up-text'
                    "
                    :href="$scope.URL_STORE_PREFIX + `/sacola`"
                ></a>
            </div>
        </header>

        <div class="content" :class="{ busy: showReview || loading > 0 || checkingOut }">
            <div class="flex-grid mt-2">
                <div class="flex-xs-12 flex-sm-12 flex-md-7">
                    <div class="pos-relative">
                        <Alert :alert="alert" />

                        <Spinner v-if="isBusy && !cart" />

                        <template v-else-if="cart">
                            <div ref="stepsContent">
                                <div class="flex-grid mt-4">
                                    <div class="flex-xs-12 flex-sm-4 flex-lg-3 pb-0">
                                        <CheckoutStepHeader
                                            ref="address"
                                            :title="$t('identification')"
                                            :step="STEP_AUTHENTICATION"
                                            :stepNumber="1"
                                            :active-step="activeStep"
                                            :allow-change="allowChangeAuth"
                                            :success="activeStep > STEP_AUTHENTICATION"
                                        />
                                    </div>
                                    <div class="flex-xs-12 flex-sm-8 flex-lg-9">
                                        <CheckoutIdentification
                                            :active-step="activeStep"
                                            class="checkout-step-frame"
                                            :summarize="activeStep > STEP_AUTHENTICATION"
                                        />
                                    </div>
                                    <div v-if="!customer" class="next-steps">
                                        <h4 class="section-title no-border d-flex pb-0">
                                            <div class="box-label-disabled box-label mr-2">2</div>
                                            <span class="text-uppercase">Entrega</span>
                                        </h4>
                                        <h4 class="section-title no-border d-flex pb-0">
                                            <div class="box-label-disabled box-label mr-2">3</div>
                                            <span class="text-uppercase">Pagamento</span>
                                        </h4>
                                    </div>
                                </div>
                                <hr v-show="activeStep >= STEP_ADDRESS" />
                                <div class="flex-grid mt-4" v-show="activeStep >= STEP_ADDRESS">
                                    <div class="flex-xs-12 flex-sm-4 flex-lg-3 pb-0">
                                        <CheckoutStepHeader
                                            ref="address"
                                            :title="$t('labeladdressshipping')"
                                            :step="STEP_ADDRESS"
                                            :stepNumber="2"
                                            :active-step="activeStep"
                                            :allow-change="activeStep > STEP_ADDRESS"
                                            :success="activeStep > STEP_ADDRESS"
                                            :hide-change-desktop="true"
                                        />
                                    </div>
                                    <div class="flex-xs-12 flex-sm-8 flex-lg-9">
                                        <CheckoutAddress
                                            :active-step="activeStep"
                                            :summarize="activeStep !== STEP_ADDRESS"
                                            class="checkout-step-frame"
                                        />
                                    </div>
                                </div>

                                <div
                                    v-if="
                                        activeStep > STEP_ADDRESS &&
                                        customer &&
                                        !customer.doc_number &&
                                        cart.address.data.country_id === 245
                                    "
                                >
                                    <p>
                                        {{
                                            $t('_checkout.updateAccountWithDocForBrazilX', [
                                                $scope.IS_REGULAR_CUSTOMER ? 'CPF' : 'CNPJ',
                                            ])
                                        }}
                                    </p>
                                    <a class="btn" href="/minha-conta/meus-dados">{{
                                        $t('_checkout.updateAccount')
                                    }}</a>
                                    <hr />
                                </div>
                                <template v-else>
                                    <!-- CARRIER -->
                                    <div class="flex-grid mt-4 summary-carrier">
                                        <div class="flex-xs-12 flex-sm-4 flex-lg-3">
                                            <!--                                        <CheckoutStepHeader-->
                                            <!--                                            v-show="-->
                                            <!--                                                !cart.is_only_virtual_products-->
                                            <!--                                            "-->
                                            <!--                                            ref="carrier"-->
                                            <!--                                            :title="$t('delivery')"-->
                                            <!--                                            :step="STEP_CARRIER"-->
                                            <!--                                            :stepNumber="2"-->
                                            <!--                                            :active-step="activeStep"-->
                                            <!--                                            :success="activeStep > STEP_CARRIER"-->
                                            <!--                                        />-->
                                        </div>
                                        <div class="flex-xs-12 flex-sm-8 flex-lg-9">
                                            <CheckoutCarrier
                                                v-show="
                                                    activeStep >= STEP_CARRIER &&
                                                    !cart.is_only_virtual_products
                                                "
                                                :summarize="activeStep !== STEP_CARRIER"
                                                class="checkout-step-frame"
                                                @pickup-store="pickupStore($event)"
                                            />
                                        </div>
                                        <hr />
                                    </div>

                                    <div
                                        class="flex-grid mt-4"
                                        v-if="hasCashback"
                                        v-show="activeStep > STEP_ADDRESS"
                                    >
                                        <div class="flex-xs-12 flex-sm-4 flex-lg-3">
                                            <CheckoutStepHeader
                                                ref="cashback"
                                                :title="'CASHBACK'"
                                                :step="3"
                                                :stepNumber="3"
                                                :active-step="3"
                                                :allow-change="false"
                                                :success="!!storeState.payment.selectedMethod"
                                            />
                                        </div>
                                        <div class="flex-xs-12 flex-sm-8 flex-lg-9 pt-3">
                                            <div class="d-flex checkout-cashback text-uppercase">
                                                <input
                                                    id="use-cashback-switch"
                                                    class="cr-switch"
                                                    type="checkbox"
                                                    :checked="cart.use_cashback"
                                                    @change="updateCashback"
                                                />
                                                <label
                                                    for="use-cashback-switch"
                                                    class="d-inline-block"
                                                >
                                                </label>
                                                Usar saldo de cashback :
                                                {{
                                                    cart.total_cashback_allowed_for_use
                                                        | formatMoney
                                                }}
                                            </div>
                                        </div>
                                        <hr />
                                    </div>

                                    <div
                                        v-if="
                                            activeStep >= STEP_ADDRESS &&
                                            activeStep !== STEP_PAYMENT
                                        "
                                        class="next-steps"
                                    >
                                        <h4 class="section-title no-border d-flex pb-0">
                                            <div class="box-label-disabled box-label mr-2">
                                                {{ activeStep + 1 }}
                                            </div>
                                            <span class="text-uppercase">Pagamento</span>
                                        </h4>
                                    </div>

                                    <!-- PAYMENT -->
                                    <div class="flex-grid mt-4" v-show="activeStep > STEP_CARRIER">
                                        <div class="flex-xs-12 flex-sm-4 flex-lg-3">
                                            <CheckoutStepHeader
                                                v-show="cart.total_paid > 0"
                                                ref="carrier"
                                                :title="$t('payment')"
                                                :step="STEP_PAYMENT"
                                                :stepNumber="hasCashback ? 4 : 3"
                                                :active-step="activeStep"
                                                :allow-change="true"
                                                :success="!!storeState.payment.selectedMethod"
                                            />
                                        </div>
                                        <div
                                            :class="{
                                                'pl-0': storeState.payment.selectedMethod,
                                            }"
                                            class="flex-xs-12 flex-sm-8 flex-lg-9"
                                        >
                                            <CheckoutPayment
                                                v-show="
                                                    activeStep >= STEP_PAYMENT &&
                                                    cart.total_paid > 0
                                                "
                                                class="checkout-step-frame"
                                            />
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <p class="text-center text-secondary">
                                <span v-if="activeStep === STEP_ADDRESS">
                                    {{ $t('_address.enterAddressToProceed') }}
                                </span>
                                <span v-if="activeStep === STEP_CARRIER">
                                    {{ $t('_checkout._shipping.enterShippingToProceed') }}
                                </span>
                            </p>

                            <LoadingButton
                                v-show="activeStep >= STEP_ADDRESS"
                                class="btn btn-lg btn-success btn-image btn-wide mt"
                                :loading="checkingOut || checkedOut"
                                :disabled="!allowCheckout"
                                @click="checkout"
                            >
                                {{ $t('_shop.toFinishOrder') }}
                                <i
                                    class="icon-cr icon-arrow-right ml-2"
                                    :class="{
                                        'animation-go-back': allowCheckout,
                                    }"
                                ></i>
                            </LoadingButton>

                            <div class="d-flex flex-justify-center mt">
                                <div class="d-flex flex-align-center">
                                    <i class="icon-cr icon-security new-up-icons mr-1"></i>
                                    <p class="text-yanone">{{ $t('cryptoSafeSite') }}</p>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="flex-xs-12 flex-sm-12 flex-md-5">
                    <CheckoutSummary
                        v-if="cart"
                        @update-cashback="updateCashback()"
                        :has-customizable-product="hasCustomizableProduct"
                    />
                </div>
            </div>
        </div>

        <CheckoutReview
            v-if="cart && showReview"
            :cart="cart"
            :has-customizable-product="hasCustomizableProduct"
            :pickup-store="storePickup"
            @hide="showReview = false"
            @checkout="checkout"
        />
    </div>
</template>

<script>
    import store from '../../script/store/checkout';
    import CheckoutReview from './CheckoutReview.vue';
    import LoadingButton from '../common/LoadingButton.vue';
    import CheckoutPayment from './CheckoutPayment.vue';
    import CheckoutCarrier from './CheckoutCarrier.vue';
    import CheckoutAddress from './CheckoutAddress.vue';
    import Alert from '../surface/alert/Alert.vue';
    import CheckoutStepHeader from './CheckoutStepHeader.vue';
    import CheckoutSummary from './CheckoutSummary.vue';
    import CheckoutCard from './CheckoutCard.vue';
    import { CHECKOUT_STEPS } from '../../script/store/checkout/consts';
    import Spinner from '../../components/feedback/spinner/Spinner.vue';
    import CheckoutIdentification from './CheckoutAuthentication.vue';
    import { facebookService } from '../../service/resource';
    import { cartStore } from '../../script/store/cart-store';

    export default {
        name: 'Checkout',

        components: {
            Spinner,
            CheckoutReview,
            LoadingButton,
            CheckoutPayment,
            CheckoutCarrier,
            Alert,
            CheckoutAddress,
            CheckoutStepHeader,
            CheckoutSummary,
            CheckoutCard,
            CheckoutIdentification,
        },

        data() {
            return {
                ...CHECKOUT_STEPS,

                storeState: store.state,

                showReview: false,
                loading: 0,

                cashbackError: null,

                storePickup: null,
            };
        },

        created() {
            facebookService
                .initiatedCheckout(this.$scope.cart_id)
                .then(() => {})
                .catch(() => {});

            this.fetchCart();
        },

        computed: {
            cart() {
                return this.storeState.cart.cart;
            },

            customer() {
                return (this.cart.customer || {}).data;
            },

            activeStep() {
                return this.storeState.step.active;
            },

            allowCheckout() {
                return store.allowCheckout();
            },

            checkingOut() {
                return this.storeState.cart.checkingOut;
            },

            checkedOut() {
                return this.storeState.cart.checkedOut;
            },

            isBusy() {
                return store.isBusy();
            },

            allowChangeAuth() {
                return store.authentication.allowChangeAuth();
            },

            storeError() {
                if (this.storeState.cart.error) {
                    return this.storeState.cart.error.i18n
                        ? this.$t(this.storeState.cart.error.msg)
                        : this.storeState.cart.error.msg;
                } else {
                    return null;
                }
            },

            alert() {
                if (this.storeError) {
                    return {
                        message: this.storeError,
                        isError: true,
                        timeout: 15000,
                    };
                }

                if (this.cashbackError) {
                    return {
                        message: this.cashbackError,
                        isError: true,
                        timeout: 15000,
                    };
                }

                return null;
            },

            hasCustomizableProduct() {
                if (this.cart.products.data) {
                    return this.cart.products.data.some((i) => i.product.is_customizable);
                }
            },

            hasCashback() {
                return this.cart.total_cashback_allowed_for_use > 0;
            },
        },

        watch: {
            alert(to) {
                if (to) {
                    cr$.byEl(this.$refs.topAnchor).scrollIntoView(500);
                }
            },
        },

        methods: {
            fetchCart() {
                store.cart
                    .fetch()
                    .then(() => {
                        store.step.next();
                        this.loading--;
                    })
                    .catch(() => {
                        this.loading--;
                    });
            },

            checkout() {
                store.cart.checkout();
            },

            updateCashback() {
                this.loading++;
                this.cashbackError = null;
                this.cart.use_cashback = !this.cart.use_cashback;
                cartStore
                    .updateProduct({
                        use_cashback: this.cart.use_cashback,
                    })
                    .then()
                    .catch(() => {
                        this.cashbackError = 'Houve um erro, tente novamente';
                    })
                    .then(() => {
                        this.fetchCart();
                        this.loading--;
                    });
            },

            pickupStore(store) {
                this.storePickup = store;
            },
        },
    };
</script>
